import parse from 'date-fns/parse'

export function toDate(dateStr) {
    return parse(dateStr);
}


// legacy

otuApp.Date = {
    toDate : toDate
}